import { useEffect } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import logo from "../../assets/images/RAPS-Logo.png";
import { retrieveConvergencePageMenu } from "../../redux/slice/convergence/convergence-pages-menu-slice";
import { RootState, useAppDispatch } from "../../redux/store";

const Convergence2023Header = () => {
  const dispatch = useAppDispatch();
  const path = "%2FConvergence-2023%2FSite-Nav";
  const { ConvergencePagesMenuData } = useSelector((state: RootState) => state.ConvergencePageMenu);
  //const { checkLogin } = useSelector((state: RootState) => state.loggedIn);
  //const userInfoData = useSelector((state: RootState) => state.userInfo.data);

  useEffect(() => {
    dispatch(retrieveConvergencePageMenu(path));
  }, [dispatch]);

  return (
    <>
      {/*<RenderAds />*/}
      <Navbar bg="dark" className="bg-primary sticky-top navbar-dark" expand="lg">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {ConvergencePagesMenuData[0]?.navBarItemsList?.map((item, index) => {
              return item.childNavigation?.length === 0 ? (
                <Nav.Link href={item.url} key={index} target={item.isTargetBlank ? "_blank" : ""} dangerouslySetInnerHTML={{ __html: item.text }}></Nav.Link>
              ) : (
                <NavDropdown id={"nav-dropdown-dark-example-" + index} title={item.text} menuVariant="dark" key={index} renderMenuOnMount={true}>
                  {item.childNavigation?.map((itm, indx) => {
                    return <NavDropdown.Item href={itm.url} key={indx} target={itm.isTargetBlank ? "_blank" : ""} dangerouslySetInnerHTML={{ __html: itm.text }}></NavDropdown.Item>;
                  })}
                </NavDropdown>
              );
            })}
          </Nav>
        </Navbar.Collapse>
        <div className="form-inline">
          <a className="navbar-brand" style={{ marginRight: 0 }} href="/"><img alt="RAPS.org" src={logo} /></a>
        </div>
      </Navbar>
    </>
  );
};

export default Convergence2023Header;